<template>
  <el-col :span="24" ref="trxContainer">
    <el-row type="flex" justify="start" align="middle" class="v-padded-s trx-title-container" ref="trxTitleContainer">
      <el-col :span="12" class="h-padded left-aligned-col">
        <el-row type="flex" align="middle" justify="start">
          <h2 style="margin: 0; font-weight: 100;">
            EDIT JOURNAL ENTRY {{ (form && form.number) ? form.number : '' }}
            ({{
              originalHeader && originalHeader.status
                ? originalHeader.status
                : ''
            }})
          </h2>
        </el-row>
      </el-col>
      <!--<el-col :span="!transactionIsBalanced || (['POSTED', 'CLOSED'].includes(originalHeader.status) && amountHasChanged) ? 8 : 0">-->
        <!--<el-row type="flex" align="middle" justify="end">-->
          <!--<el-tag type="danger" v-if="!transactionIsBalanced" style="margin: 0 12px;">-->
            <!--Unbalanced-->
          <!--</el-tag>-->
          <!--<el-tag-->
            <!--v-else-if="['POSTED', 'CLOSED'].includes(originalHeader.status) && amountHasChanged"-->
            <!--type="danger"-->
            <!--style="margin: 0 12px;">-->
            <!--Debits/Credits must equal originally Posted amount when changing Distribution Lines-->
          <!--</el-tag>-->
        <!--</el-row>-->
      <!--</el-col>-->
      <DataEntryButtons
        :status="originalHeader.status"
        :isReadOnly="readOnly"
        :hasBeenChanged="hasBeenChanged"
        :amountHasChanged="amountHasChanged"
        :isBalanced="transactionIsBalanced"
        :isSaving="isSaving"
        :isSaveable="isSaveable"
        :disableDistChanges="disableDistChanges"
        :disableAuditBtn="disableAuditBtn"
        :disablePostBtn="disablePostBtn"
        :transactionType="transactionType"
        :numberOfFiles="numberOfFiles"
        :isRecon="isRecon"
        @addNew="addNew"
        @toggleReadOnly="toggleReadOnly"
        @dropdownClick="handleDropdownClick"
        @goBack="goBack"
        @auditBtnClick="handleAuditBtnClick('Journal Entry')"
        @postBtnClick="handlePostBtnClick('Journal Entry')"
        @otherActions="otherActions"
        @submit="handleSubmit"
      />
    </el-row>
    <el-row type="flex" ref="mockTrxTitleContainer" />
    <el-row justify="start" align="start" type="flex" class="trx-header" ref="trxHeaderContainer">
      <el-col :span="8" style="margin-right: 10px">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Batch"
            :fields="fields.batch"
            :form="form"
            :idPrefix="'a-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin: 0 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Data"
            :fields="fields.jeData"
            :form="form"
            :idPrefix="'b-'"
            :modalOpen="dialogVisible"
            :isSaving="isSaving"
            @acBackspaceEvent="updateForm"
            @formatDateFields="formatDateFields"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
      <el-col :span="8" style="margin-left: 10px;">
        <el-row justify="start" align="middle" type="flex">
          <HeaderFields
            title="Transaction Info"
            :fields="fields.transactionInfo"
            :form="form"
            :idPrefix="'c-'"
            :modalOpen="dialogVisible"
            @formChanged="updateForm"
          />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="lines" justify="start" align="middle" type="flex" id="trx-lines-container">
      <DistributionLines
        v-if="dataLoaded"
        entityType="je"
        ref="distribution-lines"
        :fields="lineFields"
        :readOnly="readOnly || isSaving"
        :existingLines="originalLines"
        :modalOpen="dialogVisible"
        :parentForm="form"
        :initLines="20"
        :vendorPoLines="getPoLines"
        @viewDc="viewDc"
        @linesHaveBeenChanged="setLinesHaveBeenChanged"
        @formatMoneyFields="formatLineMoneyField"
        @updateLines="updateLines"
      />
      <LinesLoading v-else :distLinesHeight="distLinesHeight" />
    </el-row>
    <el-dialog
      title="Confirm cancellation"
      :visible.sync="dialogVisible"
      size="tiny"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Do you wish to save your changes?
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="exit-modal-btn"
          @click="cancelExit">
          Cancel
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="goBack(true)">
          No
        </el-button>
        <el-button
          class="exit-modal-btn"
          type="primary"
          @click="handleSubmit(false)">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="docs-dialog"
      title="View/Upload Documents"
      size="small"
      top="10%"
      :visible.sync="dropzoneVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <document-dialog
        :transaction="form"
        :dz-options="setupDropzoneOptions()"
        @upload-success="dzSuccess"
        @upload-error="dzFailure"
        @upload-remove="dzRemove"
      />
    </el-dialog>
    <NewBatch @populateFieldWithNewModel="populateFieldWithNewModel" />
    <DcConfirmationDialog
      :originalLines="originalLines"
      :lineDeltas="lineDeltas"
      :lineFields="lineFields"
      :visible="dcConfirmationDialogVisible"
      :allDcs="allDcs"
      :newDcs="newDcs"
      :existingDcs="existingDcs"
      :loading="creatingDc"
      @cancel="() => showDcConfirmationDialog(false)"
      @confirm="confirmDcSubmit"
    />
    <DcViewDialog
      :viewedDcId="viewedDcId"
      :viewableDcs="viewableDcs"
      :showOrClose="viewDc"
      :trxType="transactionType.name"
      :lineFields="lineFields"
      :trxId="originalHeader.id"
    />
  </el-col>
</template>

<script>
  /* eslint-disable camelcase */
  import { mapGetters } from 'vuex'
  import DistributionLines from '@/components/DistributionLinesNew.vue'
  import HeaderFields from '@/components/HeaderFields.vue'
  import NewBatch from '@/components/RouteComponents/Batches/NewBatch.vue'
  import DataEntryButtons from '@/components/DataEntryButtons.vue'
  import { isJeBalanced } from '@/utils/helpers/DataEntryViews/IsTransactionBalanced'
  import { trackHeaderChanges, trackDistributionChanges } from '@/utils/helpers/DataEntryViews/TrackChanges'
  import sortLines from '@/utils/helpers/DataEntryViews/SortLines'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { transactionEditViewMixins } from '@/Mixins/TransactionEditViews'
  import DocumentDialog from '@/components/DocumentDialog.vue'
  import LinesLoading from '@/components/LinesLoading.vue'
  import FindOrFetchBatchAndPeriod from '@/utils/helpers/DataEntryViews/FindOrFetchBatchAndPeriod'
  import store from '@/store/store'
  import DcConfirmationDialog from '@/components/DcConfirmationDialog.vue'
  import DcViewDialog from '@/components/DcViewDialog.vue'
  import { getOffsetDcJeLines, getPoLinesToRelieve, loadInitialData } from '@/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers'

  export default {
    components: {
      DistributionLines,
      HeaderFields,
      NewBatch,
      DataEntryButtons,
      DocumentDialog,
      LinesLoading,
      DcConfirmationDialog,
      DcViewDialog
    },
    mixins: [ transactionMixins, transactionEditViewMixins ],
    data () {
      const { getJeById, getJeLinesByTransactionId, getBatchById, getSourcecodeById } = this.$store.getters
      const je = getJeById(this.$route.params.id)
      let lines = this.buildLinesWithDcs(Object.values(getJeLinesByTransactionId(je.id)), je)
      return {
        transactionType: { name: 'je', path: '/jes/', prettyName: 'Journal Entry' },
        originalHeader: je,
        originalLines: lines,
        lines,
        form: {
          batch: { label: je.batch ? getBatchById(je.batch).name : '', value: je.batch || '' },
          period: je.period || '',
          source_code: { label: je.source_code ? `${getSourcecodeById(je.source_code).code} - ${getSourcecodeById(je.source_code).name}` : '', value: je.source_code || '' },
          description: je.description || '',
          date: je.date || '',
          number: je.number || '',
          debits_decimal: je.debits_decimal || '',
          credits_decimal: je.credits_decimal || '',
          confirmation_number: je.confirmation_number || '',
          original_trx_number: je.original_trx_number || '',
          effective_date: je.effective_date || '',
          status: je.status,
          amount_decimal: je.amount_decimal
        },
        headerDeltas: {},
        lineDeltas: {},
        loadingOptions: false,
        dialogVisible: false,
        readOnly: !['DRAFT', 'OPEN', 'AUDITED'].includes(je.status),
        changesWereSaved: false,
        transactionIsBalanced: !(parseFloat(je.credits_decimal) + parseFloat(je.debits_decimal)),
        transactionWasBalanced: false,
        isOpenable: false,
        amountHasChanged: false,
        statusToRestore: '',
        altRoute: null,
        ready: false,
        disableAuditBtn: false,
        disablePostBtn: false,
        isSaving: false,
        notificationBox: undefined,
        dropzoneVisible: false,
        trxAlreadyExistsMsg: null,
        vendorNumberCheckTimeout: null
      }
    },
    methods: {
      goBack (reset = false) {
        if (reset) this.hasBeenChanged = false
        this.ready = false
        this.resetInvalidChanges()
        if (this.altRoute && Object.keys(this.altRoute).length) {
          this.$router.push(this.altRoute)
        } else {
          this.$router.push({ name: 'JEs' })
        }
      },
      resetInvalidChanges () {
        if (this.originalHeader.status === 'POSTED' && this.amountHasChanged) {
          this.lineDeltas = Object.assign({})
          const headerChanges = Object.keys(this.headerDeltas)
          if (headerChanges.includes('debits_decimal')) {
            delete this.headerDeltas['debits_decimal']
          }
          if (headerChanges.includes('credits_decimal')) {
            delete this.headerDeltas['credits_decimal']
          }
          this.checkForChanges()
        }
      },
      /**
       * Submits the form.
       * @param saveOnly        Enables or disables any navigation that should occur after the transaction is saved
       * @param explicitDeltas  Specifies hard-coded deltas that need to be set, such as status
       * @param reportToRun     Specifies type of report to run once saved. Can be 'audit' or 'posting'
       */
      handleSubmit (saveOnly, explicitDeltas = null, reportToRun = null) {
        if (this.shouldCreateDcJe) {
          this.showDcConfirmationDialog(true)
          return
        }
        if (this.dialogVisible) {
          this.handleDialogVisible(false)
        }
        let removedLines = this.removeDeletedLines()
        const { headerDeltas, lineDeltas } = this
        if (explicitDeltas) {
          this.headerDeltas = Object.assign(headerDeltas, explicitDeltas)
        }
        const hDeltaCount = Object.keys(headerDeltas).length
        const lDeltaCount = Object.keys(lineDeltas).length
        if (hDeltaCount || lDeltaCount) {
          this.isSaving = true
          this.saveTransactionChanges('Je', saveOnly, reportToRun)
        } else {
          this.transactionIsBalanced = isJeBalanced(this)
          this.checkForChanges()
          if (removedLines.length) {
            removedLines.forEach(lineNum => this.$refs['distribution-lines'].removeLine(lineNum))
          }
        }
      },
      /**
       * Updates header form
       * @param form
       */
      updateForm (form, changedField = null) {
        this.form = { ...form }
        this.headerDeltas = trackHeaderChanges(this.form, this.originalHeader)
        this.checkForChanges()
        if (changedField === 'number') {
          this.checkIfTrxExists()
        }
      },
      async checkIfTrxExists () {
        clearTimeout(this.vendorNumberCheckTimeout)
        const { number } = this.form
        const data = { conditionsMet: false, action: null }
  
        data.conditionsMet = !!number
        data.action = async () => this.$store.dispatch('fetchJesWithQuery', { number })

        if (data.conditionsMet && typeof data.action === 'function') {
          try {
            const resp = await data.action()
            if (!resp) {
              throw new Error('No response')
            }
            if (resp.hasOwnProperty('count') && resp.count) {
              const id = Object.values(resp.entities[`jes`])[0].id
              this.trxAlreadyExists = true
              const h = this.$createElement
              this.trxAlreadyExistsMsg = this.$message({
                message: h('p', null, [
                  h('span', null, `A transaction with this number already exists! `),
                  h('button', { on: { click: () => this.openExistingTrx(id) } }, `Discard current & view existing JE`)
                ]),
                type: 'warning',
                duration: 0,
                showClose: true
              })
            } else {
              this.trxAlreadyExists = false
              if (this.trxAlreadyExistsMsg) this.trxAlreadyExistsMsg.close()
            }
          } catch (e) {
            console.log(e)
          }
        }
      },
      openExistingTrx (id) {
        if (this.trxAlreadyExistsMsg) {
          this.trxAlreadyExistsMsg.close()
        }
        if (id) {
          this.isSaveable = false
          return this.$router.push({ name: 'EditJe', params: { id } })
        }
      },
      /**
       * Updates distribution lines
       * @param lines
       */
      updateLines (lines) {
        this.lines = lines
        this.linesChanged()
        this.updateDebitsAndCredits()
      },
      /**
       * Fires certain actions when distribution lines are changed
       */
      linesChanged () {
        this.lineDeltas = trackDistributionChanges(this.lines, this.originalLines)
        const d = this.lineDeltas
        if (d.hasOwnProperty('new') || Object.values(d).some(v => v.hasOwnProperty('amount_decimal'))) {
          this.updateForm(this.form)
        }
        this.checkForChanges()
      },
      /**
       * Updates JE debits and credits based on distribution line balances
       */
      updateDebitsAndCredits () {
        let debits = 0
        let credits = 0
        this.lines.forEach(line => {
          if (line && line.deleteLine) return
          const amount = parseFloat(line.form.amount_decimal)
          if (amount && amount >= 0) {
            debits = debits + amount
          } else if (amount && amount < 0) {
            credits = credits + amount
          }
        })
        this.form.debits_decimal = (Math.round(debits * 100) / 100).toFixed(2)
        this.form.credits_decimal = (Math.round(credits * 100) / 100).toFixed(2)
        this.transactionIsBalanced = isJeBalanced(this)
        this.updateForm(this.form)
      },
      /**
       * Updates the header's "status" field
       */
      updateHeaderStatusField () {
        let tmp = Object.assign({}, this.form)
        tmp.status = this.originalHeader.status
        this.form = Object.assign({}, tmp)
      },
      /**
       * Disables header fields
       * TODO: deprecate
       */
      disableHeaderFields () {
        let tmpFields = Object.assign({}, this.fields)
        tmpFields.batch.inputFields.map(v => {
          if (v.name === 'batch') {
            v.disabled = true
            v.addBtn = false
          }
          return v
        })
        this.fields = Object.assign({}, tmpFields)
      },
      /**
       * Determines whether or not this transaction status can be set to 'OPEN'
       */
      checkIfOpenable () {
        const { transactionWasBalanced, transactionIsBalanced, lines } = this
        this.isOpenable = (transactionWasBalanced || transactionIsBalanced) && (lines && lines.length) // TODO: && lines are valid?
      }
    },
    computed: {
      ...mapGetters({
        getJes: 'getJes',
        getJeById: 'getJeById',
        getJeLines: 'getJeLines',
        getPoLines: 'getPoLines',
        getLineById: 'getLineById',
        getJeLinesByTransactionId: 'getJeLinesByTransactionId',
        getPeriodById: 'getPeriodById',
        currentPeriod: 'getCurrentPeriod'
      }),
      selectedPeriod () {
        const je = this.getJeById(this.$route.params.id)
        if (je && je.period && this.getPeriodById(je.period).id) {
          return this.getPeriodById(je.period)
        }
      },
      /**
       * Returns a boolean indicating whether this journal entry is a DC journal entry.
       * @return boolean
       */
      jeIsDcJe () {
        const je = this.getJeById(this.$route.params.id)
        if (je && je.source_code) {
          const sc = this.$store.getters.getSourcecodeById(je.source_code)
          return sc && sc.code === 'DC'
        }
        return false
      },
      /**
       * Returns this transaction's field definitions.
       */
      fields () {
        const je = this.getJeById(this.$route.params.id)
        let fields = {
          batch: {
            inputFields: [
              {
                name: 'batch',
                label: 'Batch Name',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'batches' },
                required: true,
                triggerOnFocus: false,
                msg: 'Please select a batch',
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status),
                addBtn: !['POSTED', 'CLOSED', 'VOIDED'].includes(je.status)
              }
            ],
            displayFields: [
              {
                name: 'batch',
                label: 'Company',
                value: this.batchAttributes.company ? this.batchAttributes.company.name : ''
              },
              {
                name: 'batch',
                label: 'Production',
                value: this.batchAttributes.production ? this.batchAttributes.production.name : ''
              },
              {
                name: 'batch',
                label: 'Bank',
                value: this.batchAttributes.bank ? this.batchAttributes.bank.name : ''
              },
              {
                name: 'batch',
                label: 'Currency',
                value: this.batchAttributes.currency ? this.batchAttributes.currency.code : ''
              }
            ]
          },
          jeData: {
            inputFields: [
              {
                name: 'description',
                label: 'Description',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status),
                msg: 'Please provide a description',
                min: 3
              },
              {
                name: 'number',
                label: 'Journal Number',
                dataType: 'string',
                fieldType: 'input',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status)
              },
              {
                name: 'amount_decimal',
                label: 'Amount',
                dataType: 'string',
                fieldType: 'input'
              },
              {
                name: 'date',
                label: 'Date',
                dataType: 'string',
                fieldType: 'date',
                required: true,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status),
                msg: 'Please specify a date'
              },
              {
                name: 'effective_date',
                label: 'Effective Date',
                dataType: 'string',
                required: this.effectiveDateMandatory,
                fieldType: 'date',
                disabled: ['CLOSED', 'VOIDED'].includes(je.status) || !!this.jeIsDcJe
              },
              {
                name: 'confirmation_number',
                label: 'Confirmation',
                dataType: 'string',
                fieldType: 'input',
                disabled: ['CLOSED', 'VOIDED'].includes(je.status)
              },
              {
                name: 'source_code',
                label: 'Source code',
                dataType: 'number',
                fieldType: 'input',
                autocomplete: true,
                searchAsync: true,
                queryData: { endpoint: 'sourcecodes' },
                triggerOnFocus: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status)
              },
              {
                name: 'period',
                label: 'Period',
                dataType: 'number',
                fieldType: 'select',
                remote: false,
                disabled: ['POSTED', 'CLOSED', 'VOIDED'].includes(je.status),
                options: [
                  { label: 'Next', value: '', selected: !(this.currentPeriod && this.currentPeriod.id) }
                ]
              }
            ]
          },
          transactionInfo: {
            existingModelFields: [
              {
                label: 'Debits',
                field: 'debits_decimal',
                value: '',
                useFormValue: true,
                prefix: this.currency ? this.currency.symbol : ''
              },
              {
                label: 'Credits',
                field: 'credits_decimal',
                value: '',
                useFormValue: true,
                prefix: this.currency ? this.currency.symbol : ''
              },
              {
                label: 'Transaction #',
                value: je.ledger || ''
              },
              {
                label: 'Date posted',
                value: je.time_posted ? this.formatDateToLocale(je.time_posted) : ''
              },
              {
                label: 'Status',
                value: '',
                useFormValue: true,
                field: 'status'
              }
            ]
          }
        }
        if (this.currentPeriod && this.currentPeriod.id) {
          fields.jeData.inputFields[7].options.push({ label: 'Current', value: this.currentPeriod.id })
        }
        if (this.selectedPeriod && this.currentPeriod && this.currentPeriod.id !== this.selectedPeriod.id) {
          fields.jeData.inputFields[7].options.push({
            label: `Ending ${this.selectedPeriod.end}`,
            value: this.selectedPeriod.id,
            selected: true
          })
        }
        return fields
      },
      isRecon () {
        if (this.batchAttributes.bank) {
          let lines = Object.values(this.getJeLinesByTransactionId(this.$route.params.id))
          return lines.filter(l => (l.recon !== null && (l.bank === this.batchAttributes.bank.id))).length > 0
        }
      }
    },
    watch: {
      getJes () {
        const newHeader = this.getJeById(this.originalHeader.id)
        if (newHeader) {
          this.originalHeader = Object.assign({}, newHeader)
          this.updateHeaderStatusField()
          this.readOnly = !['DRAFT', 'OPEN', 'AUDITED'].includes(this.originalHeader.status)
        }
      },
      getJeLines () {
        if (this.voidingDcJes) {
          return
        }
        const recent = () => {
          let incoming = Object.values(this.getJeLinesByTransactionId(this.$route.params.id))
          return this.buildLinesWithDcs(incoming, this.getJeById(this.$route.params.id))
        }
        if (this.ready && (JSON.stringify(recent()) !== JSON.stringify(this.originalLines))) { // this.ready prevents this logic from running when component is created
          this.originalLines = recent()
          this.lines = recent()
          if (this.$refs && this.$refs['distribution-lines']) {
            this.$refs['distribution-lines'].rebuildLines()
          }
        }
        this.ready = !this.isSaving
      },
      /**
       * Determines whether the transaction's amount has changed
       */
      headerDeltas () {
        const deltas = Object.keys(this.headerDeltas)
        this.amountHasChanged = deltas.includes('debits_decimal') || deltas.includes('credits_decimal')
      }
    },
    /**
     * Things that should be done when the component is created
     */
    created () {
      this.lines = sortLines(this.lines)
      this.transactionWasBalanced = isJeBalanced(this)
      if (this.originalHeader === 'DRAFT') this.checkIfOpenable()
      this.linesChanged()
      this.updateDebitsAndCredits()
      this.getDefaultData()
    },
    /**
     * Things that should be done before the route resolves and the component is created
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteEnter (to, from, next) {
      const { getJeById } = store.getters
      try {
        const resp = await store.dispatch('fetchJesWithQuery', { query: { id: to.params.id }, storeLines: true })
        let promises = [
          store.dispatch('fetchUiSetting', { name: 'LINE_FIELD_ORDER' }),
          store.dispatch('fetchUiSetting', { name: 'CONFIRM_ON_POST' })
        ]
        if (resp && resp.entities) {
          const deps = await store.dispatch('findDependencies', resp.entities) || []
          promises = [...promises, ...deps]
        }
        await Promise.all(promises)
        const je = getJeById(to.params.id)
        await getPoLinesToRelieve(je.id, 'je')
        await loadInitialData()
        if (['POSTED', 'CLOSED', 'VOIDED', 'DELETED'].includes(je.status)) {
          await getOffsetDcJeLines(to.params.id, 'je')
        }
        promises = [...FindOrFetchBatchAndPeriod(store, je)]
        if (promises.length) {
          await Promise.all(promises)
        }
        next()
      } catch (e) {
        console.log(e)
      }
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await store.dispatch('clearPoState', true)
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-form-item__label {
    padding: 20px !important;
    border: 1px solid pink;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Jes/Edit.vue